export class HistogramData {
    public n: number;
    public mean: number;
    public stdDev: number;

    public values: HistogramValue[];

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.n = json.n;
            this.mean = json.mean;
            this.stdDev = json.stdDev;
            this.values = json.values.map((valueJson: any) => new HistogramValue(valueJson));
        };
    }
}

export class HistogramValue {
    public bin: number;
    public width: number;
    public values: number[];
    public value: number;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.bin = json.bin;
            this.width = json.width;
            this.values = json.values;
            this.value = json.value;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/histogramData.ts